import { useState } from 'react';
import { useRecoilState } from 'recoil';
import { namespaceState } from '../../recoil/atoms';
import styles from './style.module.css';
import ModelFilter from './ModelFilter';
import ModelList from './ModelList';
import { dataList } from '../../constants';
import SearchBar from '../../compoenets/SearchBar';

export default function ModelCatalog(){
    const [nsState,setNsState]=useRecoilState(namespaceState);
    const [isSearchFocus,setIsSearchFocus]=useState(false);
    const [keywordData,setKeywordData]=useState(null);
    const [filterParams,setFilterParams]=useState({
        namespaceId:nsState.id,
        userId:JSON.parse(localStorage.getItem("account")).id,
        filters:{
            type:[],
            dataset:[],
            status:[],
            tags:[]
        }
    });

    const handleChange=(key,value)=>setFilterParams(prev=>{
        const filters={...prev.filters};

        if(key==='type'){
            if(filters[key].includes(value)){
                filters[key]=[];
            }
            else{
                filters[key] = [value];
                filters.dataset=filters.dataset.filter(requiredName=>
                    dataList.find(item=>item.requiredName===requiredName).category.toLowerCase()==value
                );
            }
        } else{
            if(filters[key].includes(value)){
                filters[key]=filters[key].filter(item=>item!==value);
            } else{
                filters[key]=[...filters[key],value];
            }
        }

        return {...prev,filters};
    })

    const handleClear=()=>{
        setFilterParams(prev=>({
            ...prev,
            filters:{
                type:[],
                dataset:[],
                status:[],
                tags:[]
            }
        }))
    }

    const handleSearchChange=(value)=>{
        if(value.trim()===""){
            setKeywordData(null);
            return;
        }

        if(value.trim()!==""){
            setKeywordData(value);
        }
    }

    const handleSearchClear=()=>{
            setKeywordData(null);
    }

    return(
        <div className={styles['wrap']}>
            <div className={styles['header']}>
                <span className={styles['title']}>Model Catalog</span>
                <SearchBar
                wrapStyle={`${styles['search']} ${isSearchFocus && styles['search-on']}`}
                inputStyle={`${styles['search-input']} ${isSearchFocus && styles['search-input-on']}`}
                iconStyle= {`${styles['search-icon']} ${isSearchFocus && styles['search-icon-on']}`}
                placeholder='Search keyword'
                onFocus={()=>setIsSearchFocus(true)}
                onBlur={()=>setIsSearchFocus(false)}
                onChange={handleSearchChange} 
                onClear={handleSearchClear}
                />
            </div>
            <div className={styles['body']}>
                <ModelFilter 
                className={styles['model-filter']}
                filter={filterParams}
                onChange={handleChange}
                onClear={handleClear}
                />
                <ModelList 
                className={styles['model-list']}
                filter={filterParams}
                keyword={keywordData}
                />
            </div>
        </div>
    )
}